'use strict';

import React from 'react';
import Button from 'components/clarity-ui/inputs/button';
import Select from 'components/clarity-ui/inputs/select';
import Autocomplete from 'components/clarity-ui/inputs/autocomplete';
import {
  matchTextToTerm,
  sortItems
} from 'helpers/matchers';
import {
  autocompleteListItemClassName,
  autocompleteListItemStyle
} from 'helpers/classNameStyles';

class QueryRule extends React.Component {

  renderEntitySuggestionAutocomplete () {
    const { entitiesSuggestion, item, handleSuggestionsAutocompleteSelect,
      handleSuggestionsAutocompleteOnChange, handleSuggestionsAutocompleteKeyPress } = this.props;
    return (
      <Autocomplete
        inputProps={{className:'InputField-input'}, {placeholder:'Type to Filter Entities'}}
        onSelect={handleSuggestionsAutocompleteSelect.bind(this, item)}
        onChange={handleSuggestionsAutocompleteOnChange.bind(this, item)}
        onHandleKeyUp={handleSuggestionsAutocompleteKeyPress}
        items={entitiesSuggestion}
        getItemValue={(item) => item.name}
        shouldItemRender={matchTextToTerm}
        sortItems={sortItems}
        shouldClear={false}
        renderItem={(item, isHighlighted, styles) => (
          <li
            className={autocompleteListItemClassName(isHighlighted)}
            style={autocompleteListItemStyle(isHighlighted, styles)}
            key={item.name}
          >{item.name}</li>
        )}
      />
    );
  }

  render() {
    const { item, handleDeleteButtonOnClick } = this.props;
    return (
      <div className="EntityShowCase QueryRule" name={item.name}>
        <div className="RuleBody Grid-cell--10of12">
          <div className="Grid-cell--4of12 Form-inputGroup" style={{marginBottom: 0}}>
            <label className="InputField-label">Operator</label>
            <Select>
              <option value="">Contains</option>
            </Select>
          </div>
          <div className="Grid-cell--6of12 elementPaddingLeft GroupSingleMarginTop">
            {this.renderEntitySuggestionAutocomplete()}
          </div>
          <div className="Grid-cell--2of12"></div>
        </div>
        <div className="RuleButton Grid-cell--2of12">
          <div className="floatRightAlign">
            <Button className='Small CustomWhite WithRed' onClick={handleDeleteButtonOnClick}>Delete</Button>
          </div>
        </div>
      </div>
    );
  }
}

export default QueryRule;



// WEBPACK FOOTER //
// ./src/components/entityRecommender/queryBuilder/queryRule.component.jsx